class ProductFeaturesSettings {
  isInitiallyOpen: boolean;
}

const productFeaturesSettings = new ProductFeaturesSettings();

productFeaturesSettings.isInitiallyOpen = true;

export {ProductFeaturesSettings, productFeaturesSettings};